import React, { useState, useEffect } from "react";
import {
  MapPin,
  Phone,
  Mail,
  Send,
  MessageCircle,
  Clock,
  PhoneCall,
  } from "lucide-react";

export default function Contact() {
  // Form State Management
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    service: "General Inquiry",
    message: "",
  });

  useEffect(() => {
    document.title = "CMJ Global | Contact Us";
  }, []);

  // Handle Input Changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // WhatsApp Submission Logic
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    // Replace this with your actual company WhatsApp number (include country code, no + or spaces)
    const companyWhatsAppNumber = "918369337638";

    // Format the message for WhatsApp
    const whatsappMessage = `*New Enquiry via Website*%0A%0A*Name:* ${formData.name}%0A*Company:* ${formData.company}%0A*Email:* ${formData.email}%0A*Service:* ${formData.service}%0A%0A*Message:*%0A${formData.message}`;

    // Open WhatsApp in a new tab with the pre-filled message
    window.open(
      `https://wa.me/${companyWhatsAppNumber}?text=${whatsappMessage}`,
      "_blank",
    );
  };

  return (
    <div className="bg-[#F9F8F3] min-h-screen pt-24 pb-20 font-sans">
      {/* Page Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16 text-center">
        <span className="text-xs font-bold text-[#87412A] uppercase tracking-widest block mb-2">
          Get In Touch
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-[#1E4363] font-serif mb-6 uppercase tracking-tight">
          Contact CMJ Global
        </h1>
        <div className="w-20 h-1 bg-[#87412A] mx-auto mb-6"></div>
        <p className="text-[#2C3539]/80 max-w-2xl mx-auto text-lg">
          Reach out for expert maritime consultancy, survey quotations, or
          general inquiries. Our team is ready to assist you worldwide.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* LEFT COLUMN: Contact & Bank Info */}
          <div className="lg:col-span-5 space-y-8">
            {/* Contact Details Card */}
            <div className="bg-white p-8 border border-gray-200 rounded-sm shadow-sm">
              <h3 className="text-2xl font-bold text-[#1E4363] font-serif mb-6">
                Corporate Office
              </h3>

              <ul className="space-y-6">
                <li className="flex items-start gap-4">
                  <div className="p-3 bg-[#1E4363]/5 text-[#1E4363] rounded-sm">
                    <MapPin size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-[#2C3539] mb-1">Address</h4>
                    <p className="text-[#2C3539]/70 text-sm leading-relaxed">
                      26-A, Mahalaxmi Darshan Appts,<br />
                      Mahalaxmi Temple Compound,<br />
                      B. Desai Road, Cumballa Hill,<br />
                      Mumbai - 400026.

                    </p>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <div className="p-3 bg-[#1E4363]/5 text-[#1E4363] rounded-sm">
                    <Phone size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-[#2C3539] mb-1">Phone</h4>
                    <p className="text-[#2C3539]/70 text-sm">+91 83693 37638</p>
                    <p className="text-[#2C3539]/70 text-sm">
                      +91 99696 38163
                    </p>
                  </div>
                </li>

                <li className="flex items-start gap-4">
                  <div className="p-3 bg-[#1E4363]/5 text-[#1E4363] rounded-sm">
                    <Mail size={24} />
                  </div>
                  <div>
                    <h4 className="font-bold text-[#2C3539] mb-1">Email</h4>
                    <p className="text-[#2C3539]/70 text-sm">
                      info@cmjglobal.in
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Bank Information Card */}
            {/* <div className="bg-[#1E4363] text-white p-8 rounded-sm shadow-lg border-t-4 border-[#87412A] relative overflow-hidden">
              Decorative background icon
              <Building2 size={120} className="absolute -bottom-6 -right-6 text-white/5 pointer-events-none" />
              
              <div className="flex items-center gap-3 mb-6 relative z-10">
                <Landmark size={28} className="text-[#87412A]" />
                <h3 className="text-2xl font-bold font-serif">Bank Details</h3>
              </div>
              
              <div className="space-y-4 relative z-10">
                <div>
                  <p className="text-xs text-white/60 uppercase tracking-wider mb-1">Account Name</p>
                  <p className="font-semibold tracking-wide">CMJ GLOBAL SERVICES PVT LTD</p>
                </div>
                <div className="grid grid-cols-2 gap-4 border-t border-white/10 pt-4">
                  <div>
                    <p className="text-xs text-white/60 uppercase tracking-wider mb-1">Bank Name</p>
                    <p className="font-semibold">[Your Bank Name]</p>
                  </div>
                  <div>
                    <p className="text-xs text-white/60 uppercase tracking-wider mb-1">Branch</p>
                    <p className="font-semibold">[Branch Name]</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 border-t border-white/10 pt-4">
                  <div>
                    <p className="text-xs text-white/60 uppercase tracking-wider mb-1">Account No.</p>
                    <p className="font-semibold tracking-wider">[1234567890]</p>
                  </div>
                  <div>
                    <p className="text-xs text-white/60 uppercase tracking-wider mb-1">IFSC / SWIFT</p>
                    <p className="font-semibold tracking-wider">[ABCD0123456]</p>
                  </div>
                </div>
              </div>
            </div> */}
            {/* 24/7 Operations Box */}
            <div className="bg-[#1E4363] text-white p-8 rounded-sm shadow-lg border-t-4 border-[#87412A] relative overflow-hidden">
              {/* Decorative background icon */}
              <Clock
                size={120}
                className="absolute -bottom-6 -right-6 text-white/5 pointer-events-none"
              />

              <div className="flex items-center gap-3 mb-6 relative z-10">
                <Clock size={28} className="text-[#87412A]" />
                <h3 className="text-2xl font-bold font-serif">
                  24/7 Operations
                </h3>
              </div>

              <div className="space-y-4 relative z-10">
                <p className="text-sm text-white/80 leading-relaxed mb-2">
                  Maritime operations operate around the clock, and so do we.
                  For urgent casualty investigations, cargo disputes, or
                  immediate vetting assistance, our duty desk is always open.
                </p>
                <div className="border-t border-white/10 pt-4 mt-4">
                  <p className="text-xs text-white/60 uppercase tracking-wider mb-1">
                    Emergency Contact / Duty Officer
                  </p>
                  <p className="font-semibold tracking-wide flex items-center gap-2">
                    <PhoneCall size={16} className="text-[#87412A]" /> +91 83693 37638
                  </p>
                  <p className="font-semibold tracking-wide flex items-center gap-2">
                    <PhoneCall size={16} className="text-[#87412A]" /> +91 99696 38163
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: WhatsApp Enquiry Form */}
          <div className="lg:col-span-7">
            <div className="bg-white p-8 md:p-12 border border-gray-200 rounded-sm shadow-sm h-full">
              <div className="flex items-center justify-between mb-8">
                <h3 className="text-2xl font-bold text-[#1E4363] font-serif">
                  Send an Enquiry
                </h3>
                <MessageCircle className="text-[#25D366]" size={32} />{" "}
                {/* WhatsApp Brand Color */}
              </div>

              <form onSubmit={handleWhatsAppSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Name Input */}
                  <div>
                    <label className="block text-sm font-bold text-[#2C3539] mb-2">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-[#F9F8F3] border border-gray-200 rounded-sm focus:outline-none focus:border-[#1E4363] focus:ring-1 focus:ring-[#1E4363] transition-colors"
                      placeholder="Capt. John Doe"
                    />
                  </div>

                  {/* Company Input */}
                  <div>
                    <label className="block text-sm font-bold text-[#2C3539] mb-2">
                      Company Name
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-[#F9F8F3] border border-gray-200 rounded-sm focus:outline-none focus:border-[#1E4363] focus:ring-1 focus:ring-[#1E4363] transition-colors"
                      placeholder="Oceanic Shipping Ltd."
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Email Input */}
                  <div>
                    <label className="block text-sm font-bold text-[#2C3539] mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-[#F9F8F3] border border-gray-200 rounded-sm focus:outline-none focus:border-[#1E4363] focus:ring-1 focus:ring-[#1E4363] transition-colors"
                      placeholder="john@example.com"
                    />
                  </div>

                  {/* Service Dropdown */}
                  <div>
                    <label className="block text-sm font-bold text-[#2C3539] mb-2">
                      Service of Interest
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      className="w-full px-4 py-3 bg-[#F9F8F3] border border-gray-200 rounded-sm focus:outline-none focus:border-[#1E4363] focus:ring-1 focus:ring-[#1E4363] transition-colors appearance-none"
                    >
                      <option value="General Inquiry">General Inquiry</option>
                      <option value="Cargo & Damage Surveys">
                        Cargo & Damage Surveys
                      </option>
                      <option value="Pre-Vetting / RightShip">
                        Pre-Vetting / RightShip
                      </option>
                      <option value="Audits (ISM/ISPS/TMSA)">
                        Audits (ISM/ISPS/TMSA)
                      </option>
                      <option value="Draft & Bunker Surveys">
                        Draft & Bunker Surveys
                      </option>
                      <option value="Port Captaincy">Port Captaincy</option>
                    </select>
                  </div>
                </div>

                {/* Message Textarea */}
                <div>
                  <label className="block text-sm font-bold text-[#2C3539] mb-2">
                    Your Message *
                  </label>
                  <textarea
                    name="message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    className="w-full px-4 py-3 bg-[#F9F8F3] border border-gray-200 rounded-sm focus:outline-none focus:border-[#1E4363] focus:ring-1 focus:ring-[#1E4363] transition-colors resize-none"
                    placeholder="Please provide details about your vessel, location, or specific requirements..."
                  ></textarea>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  className="w-full bg-[#1E4363] text-white py-4 px-6 rounded-sm font-bold tracking-wider hover:bg-[#87412A] transition-colors duration-300 flex items-center justify-center gap-3 group"
                >
                  <Send
                    size={20}
                    className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"
                  />
                  SEND VIA WHATSAPP
                </button>
                <p className="text-center text-xs text-[#2C3539]/50 mt-4">
                  Clicking this button will open WhatsApp with your
                  pre-formatted message.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
